module.exports = __webpack_public_path__ + "img/red-cel.159b9e4c.png";